import ReportPdfPreview from './ReportPdfPreview';
import './SendReportEmailModalStyles.scss';
const meta = {
    title: 'Features/Reports/SendReportEmailModal/ReportPdfPreview',
    component: ReportPdfPreview,
    parameters: { layout: 'fullscreen' },
    args: { pdfUrl: 'https://d1ubp9hvv96vde.cloudfront.net/tenant5/report.pdf' }
};
export default meta;
export const Default = {};
export const TooLargeToAutoLoad = {
    args: { autoLoad: false, sizeLabel: '286 MB' }
};
